var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import './App.css';
import './assets/styles/common-styles.scss';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import 'react-day-picker/lib/style.css';
import 'react-toastify/dist/ReactToastify.css';
import { HashRouter, Switch, Route, Redirect } from "react-router-dom";
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './store/index';
import { getItem, PUBLISHERS_KEY, PUBLISHERS_WITH_FILTER_KEY, PUBLISHERS_WITHOUT_FILTER_KEY, removeItem } from './utils/LocalStorageUtil';
import { TOKEN_KEY } from './utils/StorageKeys';
import Dashboard from './pages/dashboard/index';
import AddWidget from './pages/add-widget/index';
import Login from './pages/login/index';
import Administration from './pages/admin/index';
import WidgetDetails from './pages/widget-details/index';
import ReportPage from './pages/report/index';
import ReportBuilderPage from './pages/report-builder/index';
import NoteDetailsPage from './pages/note-details/index';
import AlertDetailsPage from './pages/alert-card-details/index';
import ForgotPassword from './pages/forgot-password/index';
import Alert from './pages/alert/index';
import ReportQueuePage from './pages/report-queue/index';
import PublisherManual from './pages/publisher-manual/index';
import ScheduleReportPage from './pages/schedule-report/index';
import GamNetwork from './pages/gam/network/index';
import GamLineItem from './pages/gam/lineitems/index';
import NotificationPage from './pages/notifications/index';
import APISettingPage from './pages/api-setting/index';
import InventoriesPage from './pages/inventories/index';
import { authMiddleware } from './middlewares/authMiddleware';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { GLOBAL_UPDATE_INTERVAL } from './config/index';
import { getNotificationGlobal, resetNotificationGlobalInfo } from './store/notification/actions';
import { getAnnouncementLatest, resetAnnouncementLatestInfo } from './store/announcement/actions';
import { initAnalytics, syncUserIdToDataLayer } from './utils/analytics';
initAnalytics();
var enhancers = [
    applyMiddleware(thunk, authMiddleware),
];
var store = createStore(rootReducer, {}, compose.apply(void 0, enhancers));
var isAuthenticated = function () {
    var token = getItem(TOKEN_KEY);
    return token ? true : false;
};
var PrivateRoute = function (_a) {
    var Component = _a.component, authed = _a.authed, rest = __rest(_a, ["component", "authed"]);
    return (React.createElement(Route, __assign({}, rest, { render: function (props) { return (isAuthenticated() === true
            ? (React.createElement(Component, __assign({}, props)))
            : (React.createElement(Redirect, { to: { pathname: '/login', state: { from: props.location } } }))); } })));
};
export default function App() {
    var _this = this;
    var _a = useState(false), isLoggedIn = _a[0], setLoggedIn = _a[1];
    var intervalGlobal = null;
    useEffect(function () {
        var token = getItem(TOKEN_KEY);
        setLoggedIn(token ? true : false);
        syncUserIdToDataLayer();
        checkNotificationGlobal();
        getAnnouncementLatestInterval();
        // window.addEventListener("beforeunload", handleBeforeUnload);
        (function () {
            resetNotificationGlobalInfo();
            resetAnnouncementLatestInfo();
            clearInterval(intervalGlobal);
            // window.removeEventListener("beforeunload", handleBeforeUnload);
        });
    }, []);
    var handleBeforeUnload = function () {
        removeItem(PUBLISHERS_KEY);
        removeItem(PUBLISHERS_WITHOUT_FILTER_KEY);
        removeItem(PUBLISHERS_WITH_FILTER_KEY);
    };
    var checkNotificationGlobal = function () {
        if (GLOBAL_UPDATE_INTERVAL) {
            intervalGlobal = setInterval(function () {
                getNotificationGlobalInterval();
                getAnnouncementLatestInterval();
            }, GLOBAL_UPDATE_INTERVAL);
        }
    };
    var getNotificationGlobalInterval = function () { return __awaiter(_this, void 0, void 0, function () {
        var access_token;
        return __generator(this, function (_a) {
            access_token = getItem(TOKEN_KEY);
            store.dispatch(getNotificationGlobal({ access_token: access_token }));
            return [2 /*return*/];
        });
    }); };
    var getAnnouncementLatestInterval = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            store.dispatch(getAnnouncementLatest());
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(Provider, { store: store },
        React.createElement(HashRouter, null,
            React.createElement(DndProvider, { backend: HTML5Backend },
                React.createElement(Switch, null,
                    React.createElement(Route, { path: "/login", component: Login }),
                    React.createElement(Route, { path: "/forgot-password", component: ForgotPassword }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/dashboard', component: Dashboard, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/add-widget', component: AddWidget, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/admin', component: Administration, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/widget/:widgetCode', component: WidgetDetails, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/report', component: ReportPage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/report-queue', component: ReportQueuePage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/report-builder', component: ReportBuilderPage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/report-builder/create', component: ReportBuilderPage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/report-builder/:reportGroupId/:reportGroupType', component: ReportBuilderPage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/note-calendar/details', component: NoteDetailsPage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/note-calendar/details/create', component: NoteDetailsPage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/note-calendar/details/:noteId/Edit', component: NoteDetailsPage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: "/alert/:alertId/detail", component: AlertDetailsPage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/alert', component: Alert, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/alert/create', component: Alert, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/alert/:alertId/edit', component: Alert, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/alert/:alertId/clone', component: Alert, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: "/biddingNetworks", component: GamNetwork, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: "/biddingLineItems", component: GamLineItem, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/biddingLineItems/create', component: GamLineItem, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/biddingLineItems/:lineItemMappingId/edit', component: GamLineItem, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/notifications', component: NotificationPage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/publisher-manual', component: PublisherManual, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/api-setting', component: APISettingPage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/inventories', component: InventoriesPage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: "/inventories/:publisherId/:inventoryId/edit", component: InventoriesPage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/schedule-report', component: ScheduleReportPage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/schedule-report/create', component: ScheduleReportPage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: '/schedule-report/:reportGroupId/:reportTypeId/create', component: ScheduleReportPage, exact: true }),
                    React.createElement(PrivateRoute, { authed: isAuthenticated(), path: "/schedule-report/:scheduleReportId/edit", component: ScheduleReportPage, exact: true }),
                    React.createElement(Route, { exact: true, path: '/' }, isLoggedIn ?
                        React.createElement(Redirect, { to: "/dashboard" }) :
                        React.createElement(Redirect, { to: "/login" })))),
            React.createElement(ToastContainer, null))));
}
